import React, { useEffect, useState } from 'react'
import axios from 'axios';
import MyLoader from '../Spinner/MyLoader';
import COLORS from '../resources/colors/COLORS';
import SessionManager from '../Utils/SessionManager';
import {BrowserRouter as Router,Link, Redirect, Route, useParams } from 'react-router-dom';
import '../css/Admin_css/admin-customize.css';
import myToast from '../Utils/MyToast';
import Iframe from 'react-iframe'
import MdlSelectMultipleStudent from '../dialog/MdlSelectMultipleStudent';
import MdlSelectExam from '../dialog/MdlSelectExam';

export default function PrintableDocsDeskSlip(props){

	const { document_type } = useParams();
	const token = localStorage.getItem("token");
	const initialLoggedIn = token != null;

	const [loggedIn] = useState(initialLoggedIn);
	const [Loading, setLoading] = useState(false);
	const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
	const [isOpenSelectExam, setIsOpenSelectExam] = useState(false);
	const [showPrintable, setShowPrintable] = useState(false);
	const [Total, setTotal] = useState(0);
	const [mSelectedStudent, setMSelectedStudent] = useState([]);
	const [mPrintableSamples, setMPrintableSamples] = useState([]);
	const [mColorOption, setMColorOption] = useState([]);
	const [iFrameHeight, setIFrameHeight] = useState('0px');
	const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState('');
	const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
	const [SELECTION_TYPE, setSELECTION_TYPE] = useState('');
	const [FILE_URL, setFILE_URL] = useState('');
	const [FILE_NAME, setFILE_NAME] = useState('');
	const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState('');
	const [DOCUMENT_TYPE, setDOCUMENT_TYPE] = useState('');
	const [COLOR_OPTION_ID, setCOLOR_OPTION_ID] = useState('');
	const [EXAM_ID, setEXAM_ID] = useState('');
	const [EXAM_NAME, setEXAM_NAME] = useState('');

	useEffect(() => {
		setDOCUMENT_TYPE(document_type);
	}, [document_type]);

	useEffect(() => {
		if (DOCUMENT_TYPE) {
			getPrintableSamples();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [DOCUMENT_TYPE]);

	const HandleCloseSelectStudent = () => {
		setIsOpenSelectStudent(false);
	};

	const HandleSelectedStudent = (selectedStudents) => {
		if (selectedStudents == null) {
			selectedStudents = [];
		}
		setIsOpenSelectStudent(false);
		setShowPrintable(true);
		setMSelectedStudent(selectedStudents);
		setSELECTION_TYPE('student');
		setFileUrL(selectedStudents, 'student');
	};

	const HandleCloseSelectExam = () => {
		setIsOpenSelectExam(false);
	};

	const HandleSelectedExam = (exam_id, exam_name) => {
		setEXAM_ID(exam_id);
		setEXAM_NAME(exam_name);
		HandleCloseSelectExam();
	};

	const SelectStudent = () => {
		setIsOpenSelectStudent(true);
	};
	const SelectExam = () => {
		setIsOpenSelectExam(true);
	};

	const getPrintableSamples = () => {
		setLoading(true);
		const SCHOOL_CODE = SessionManager.getSchoolCode();
		const FUNCTION_NAME = 'getPrintableSample.php?';
		const URL = process.env.REACT_APP_SERVER_NAME + process.env.REACT_APP_TARGET_DIR + FUNCTION_NAME;
		// console.log("URL>>>>>"+URL);

		axios.get(URL, {
			params: {
				school_code: SCHOOL_CODE,
				document_type: DOCUMENT_TYPE,
			}
		}).then(res => res.data)
			.then((response) => {
				setLoading(false);
				let api_status = response.api_status;
				if (api_status == "OK") {
					setMPrintableSamples(response.data || []);
					setSample(SELECTED_SAMPLE_POSITION, response.data || []);
				}
				else {
					let api_remark = response.api_remark;
					myToast.notify_warning(api_remark);
				}
			}).catch((error) => {
				setLoading(false);
				console.log("error>>>>>" + error);
			});
	};

	const setSample = (selected_sample_position, samples = mPrintableSamples) => {
		if (!samples || samples.length === 0) {
			return;
		}
		const sample = samples[selected_sample_position] || samples[0];
		setSELECTED_SAMPLE_POSITION(selected_sample_position || 0);
		setFILE_NAME(sample.file_name);
		setFILE_DIRECTORY(sample.file_directory);
		setSELECTED_SAMPLE_ID(sample.sample_id);
		getColorOptions(selected_sample_position || 0, samples);
	};

	const getColorOptions = (selected_sample_position, samples = mPrintableSamples) => {
		const options = (samples && samples[selected_sample_position] && samples[selected_sample_position].color_options) || [];
		setMColorOption(options);
		setColorOptions(0, options);
	};

	const setColorOptions = (selected_position_color_option, options = mColorOption) => {
		if (options != null && options.length !== 0) {
			setCOLOR_OPTION_ID(options[selected_position_color_option].color_option_id);
		} else {
			setCOLOR_OPTION_ID('');
		}
		if (mSelectedStudent.length !== 0) {
			setFileUrL(mSelectedStudent, SELECTION_TYPE);
		}
	};

	const setFileUrL = (selectedStudents = mSelectedStudent, selectionType = SELECTION_TYPE) => {
		let class_id = "";
		let section_id = "";
		let session_id = "";
		const SCHOOL_CODE = SessionManager.getSchoolCode();
		let mStudentIds = [];

		if (selectionType === 'student') {
			for (let index = 0; index < (selectedStudents || []).length; index++) {
				const element = selectedStudents[index];
				const student_id = element.student_enrollment_no;
				session_id = element.session_id;
				mStudentIds[index] = student_id;
			}
		}
		const url = process.env.REACT_APP_SERVER_NAME + FILE_DIRECTORY + FILE_NAME + '?&student_ids=' + JSON.stringify(mStudentIds) + '&class_id=' + class_id + '&section_id=' + section_id + '&session_id=' + session_id + '&sample_id=' + SELECTED_SAMPLE_ID + '&selection_type=' + selectionType + '&system_code=' + process.env.REACT_APP_SYSTEM_CODE + '&color_option_id=' + COLOR_OPTION_ID + '&exam_id=' + EXAM_ID + '&exam_name=' + encodeURIComponent(EXAM_NAME || '') + '&school_code=' + SCHOOL_CODE;
		setFILE_URL(url);
		setShowPrintable(true);
		console.log("url>>>>>"+url);
	};

	const changeSample = (position) => {
		setSELECTED_SAMPLE_POSITION(position);
		setSample(position);
	};

	if (loggedIn == false) {
		return <Redirect to='/Login'/>;
	}
	if (Loading) {
		return <MyLoader/>;
	}
	return (
		<div className="content">
			<div className="content-header" style={{background:COLORS.primary_color_shade5}}>
				<div className="leftside-content-header">
					<ul className="breadcrumbs">
						<li><i className="fa fa-home" aria-hidden="true" style={{color:COLORS.white}} /><a href="#">{mPrintableSamples.length!=0? "Printable-"+mPrintableSamples[0].document_caption:"Printable"}</a></li>
					</ul>
				</div>
			</div>

			<div className="animated fadeInUpn bg_page_white_rounded box_shadow" style={{'--mMargin':'50px',padding:'20px'}}>

				<div className="row bg_card_primary_outline">
					<div className="col-sm-6 col-lg-6 padding_0">
						<div className="  gravity_center_vertical" style={{padding:'5px',color:'#000',margin:'0px 5px 0px 0px'}}>
							<div className="gravity_center width_match_parent margin_5 padding_5" onClick={SelectStudent}>
								<h4> {'Selected Exam: '+EXAM_NAME}</h4>
							</div>
						</div>
					</div>
					<div className="col-sm-6 col-lg-6 padding_0 "  onClick={() => {}}>
						<div className=" " style={{padding:'5px',color:'#fff',margin:'0px 5px 0px 0px'}}>
							<div className="bg_card_primary gravity_center width_match_parent margin_5 padding_5"  onClick={SelectExam}>
								<h5 className="arrow"> Select Exam</h5>
							</div>
						</div>
					</div>

				</div>
				<div className="row">
					<div className="col-sm-6 col-lg-6 padding_0">
						<div className=" bg_card_primary_outline gravity_center_vertical" style={{padding:'5px',color:'#fff',margin:'0px 5px 0px 0px'}}>
							<div className="bg_card_primary gravity_center width_match_parent margin_5 padding_5" onClick={SelectStudent}>
								<h5 className="arrow"> Select Students Manually</h5>
							</div>
						</div>
					</div>
					<div className="col-sm-6 col-lg-6 padding_0 ">
						<div className="bg_card_primary_outline  " style={{padding:'5px',color:'#fff',margin:'0px 5px 0px 0px'}}>
							<div className="bg_card_primary gravity_center width_match_parent margin_5 padding_5"  onClick={SelectStudent}>
								<h5 className="arrow"> Select Class</h5>
							</div>
						</div>
					</div>

				</div>
				<div className="row">
					<div className="col-sm-6 col-lg-6 padding_0"  >
						<div className="" style={{padding:'5px',color:'#000',margin:'0px 5px 0px 0px'}}>
							<h5 className="">Sample List</h5>
						</div>
					</div>
					<div className="col-sm-6 col-lg-6 padding_0 ">

					</div>

				</div>

				<div className="row bg_card_grey_outline" style={{height:'140px'}}>

					{mPrintableSamples && mPrintableSamples.map((item, index) => (


						<div className="col-sm-2 col-lg-2 padding_0 height_match_parent" >
							<div className={SELECTED_SAMPLE_POSITION==index? 'bg_card_green_outline cursor':'bg_card_grey_outline cursor'} style={{padding:'5px',color:'#fff',margin:'5px 10px 0px 10px',height:'110px'}} onClick={e=>changeSample(index)}>
								<div className="gravity_center">
									<img src={item.sample_img} className="img_logo" />
								</div>

							</div>
							<div className="gravity_center">
								{item.sample_name}
							</div>
						</div>
					))}

				</div>



				<div className="row" style={{margin:'0px'}}>
					<h5 className="">Preview</h5>
				</div>


				<div className="row"  style={{margin:'0px'}}>
					{showPrintable ? <div><MyLoader/></div> 

						: ''}
					<Iframe url={FILE_URL}
						width="100%"
						height="800px"
						overflow="visible"
						id="iFrameStudentId"
						className="bg_card_primary_outline"
						display="initial"
						position="relative"
						onLoad={() => {
							setShowPrintable(false)
						}} 
					/>

				</div> 

			</div>
			{isOpenSelectStudent===true? <MdlSelectMultipleStudent actionClose={HandleCloseSelectStudent} actionHandleSelected={HandleSelectedStudent}></MdlSelectMultipleStudent>:''}
			{isOpenSelectExam===true? <MdlSelectExam action_close={HandleCloseSelectExam} action_select={HandleSelectedExam}></MdlSelectExam>:''}

		</div>
	);
}
